<template>
  <div>
    <!-- NAVBAR -->
    <nav
      id="navbar"
      :class="[
        'bg-white py-4 px-6 flex items-center justify-between z-50 relative',
        isMenuOpen ? '' : 'shadow-md',
      ]"
    >
      <!-- Logo -->
      <div
        class="flex flex-col items-start font-bold text-red-600 z-50 leading-tight"
      >
        <span class="text-2xl ml-2">সাংস্কৃতিক দাপোণ</span>
        <span class="text-base ml-2 text-red-500 font-medium tracking-wide">
          Cultural Newspapers Dapon
        </span>
      </div>

      <!-- Hamburger Icon -->
      <button
        @click="toggleMenu"
        class="md:hidden text-gray-600 focus:outline-none z-50"
      >
        <div class="w-6 h-6 relative">
          <span
            :class="[
              'absolute w-full h-0.5 bg-gray-600 left-0 transition-transform duration-300',
              isMenuOpen ? 'rotate-45 top-3' : 'top-1',
            ]"
          ></span>
          <span
            :class="[
              'absolute w-full h-0.5 bg-gray-600 left-0 transition-opacity duration-300',
              isMenuOpen ? 'opacity-0' : 'top-3',
            ]"
          ></span>
          <span
            :class="[
              'absolute w-full h-0.5 bg-gray-600 left-0 transition-transform duration-300',
              isMenuOpen ? '-rotate-45 top-3' : 'top-5',
            ]"
          ></span>
        </div>
      </button>

      <!-- DESKTOP LINKS -->
      <div class="hidden md:flex items-center space-x-6">
        <ul class="flex space-x-6 text-gray-600 font-medium">
          <li><router-link to="/" class="nav-link">Home</router-link></li>
          <li>
            <router-link to="/gallery" class="nav-link">Gallery</router-link>
          </li>
          <li>
            <router-link to="/about" class="nav-link">About Us</router-link>
          </li>
          <li>
            <router-link to="/suggestion" class="nav-link"
              >Suggestion</router-link
            >
          </li>
          <li>
            <router-link to="/contact" class="nav-link">Contact Us</router-link>
          </li>
        </ul>
      </div>

      <!-- DESKTOP BUTTONS -->
  <div class="hidden md:flex items-center space-x-4">
        <template v-if="!loggedIn">
          <router-link
            to="/login"
            class="bg-white border-2 border-[#BF3131] text-[#BF3131] px-4 py-2 rounded-md font-semibold hover:bg-[#BF3131] hover:text-white transition"
            >শিল্পীয়ে নিজৰ পৰিচয় প্ৰকাশ কৰক</router-link
          >

          <div
        class="flex flex-col items-start font-bold text-red-600 z-50 leading-tight"
      >
        <span class="text-2xl ml-2">সাংস্কৃতিক আলোচনী দাপোণ</span>
        <span class="text-base ml-2 text-red-500 font-medium tracking-wide">
          Cultural Magazine Dapon
        </span>
      </div>
        </template>

        <template v-else>

          <div class="flex items-center space-x-2 border border-gray-200 rounded-full px-2 py-1 bg-gray-50">
            <!-- Avatar Circle -->
            <div class="w-8 h-8 rounded-full bg-indigo-500 flex items-center justify-center text-white font-bold text-sm">
              {{ userInitial }}
            </div>
            <!-- Name -->
            <span class="text-gray-700 font-medium text-sm max-w-[150px] truncate" :title="userName">
              Hi, {{ userName }}
            </span>
          </div>

          <router-link
            v-if="userRole === 'admin'"
            to="/admin/dashboard"
            class="bg-[#FFE9A0] border-2 border-white text-black px-4 py-2 rounded-md font-semibold hover:bg-[#FFD580] hover:text-black transition"
            >Admin Dashboard</router-link
          >
          <router-link
            v-else
            to="/artist"
            class="bg-[#FFE9A0] border-2 border-white text-white px-4 py-2 rounded-md font-semibold hover:bg-[#FFD580] hover:text-white transition"
            >Profile</router-link
          >

          <button
            @click="logout"
            class="bg-[#BF3131] text-white px-4 py-2 rounded-md font-semibold hover:bg-red-700 transition"
          >
            Logout
          </button>
        </template>
      </div>
    </nav>
    


    <!-- MOBILE MENU -->
    <div
      v-if="isMenuOpen"
      class="fixed inset-0 bg-white z-40 flex flex-col justify-center items-center space-y-8 px-6"
    >
      <ul class="text-center space-y-6 text-xl text-gray-700 font-semibold">
        <li>
          <router-link @click="closeMenu" to="/" class="nav-link"
            >Home</router-link
          >
        </li>
        <li>
          <router-link @click="closeMenu" to="/gallery" class="nav-link"
            >Gallery</router-link
          >
        </li>
        <li>
          <router-link @click="closeMenu" to="/about" class="nav-link"
            >About Us</router-link
          >
        </li>
        <li>
          <router-link @click="closeMenu" to="/suggestion" class="nav-link"
            >Suggestion</router-link
          >
        </li>
        <li>
          <router-link @click="closeMenu" to="/contact" class="nav-link"
            >Contact Us</router-link
          >
        </li>

        <template v-if="loggedIn">

          <li>
             <router-link v-if="userRole === 'admin'" @click="closeMenu" to="/admin/dashboard" class="nav-link"
              >Admin Dashboard</router-link
            >
            <router-link v-else @click="closeMenu" to="/artist" class="nav-link"
              >Profile</router-link
            >
          </li>
        </template>
      </ul>

      <!-- MOBILE BUTTONS -->
      <div
        class="absolute bottom-10 flex flex-col items-center space-y-4 w-full px-6"
      >
        <template v-if="!loggedIn">
          <router-link
            @click="closeMenu"
            to="/login"
            class="bg-white border-2 border-[#BF3131] text-[#BF3131] px-4 py-2 rounded-md font-semibold hover:bg-[#BF3131] hover:text-white transition"
            >শিল্পীয়ে নিজৰ পৰিচয় প্ৰকাশ কৰক</router-link
          >

          <router-link
            @click="closeMenu"
            to="/subscribe"
            class="bg-[#FFE9A0] text-black px-4 py-2 rounded-md font-semibold hover:bg-[#FFD580] transition inline-block text-center"
            >Subscribe</router-link
          >
        </template>

        <template v-else>
          <button
            @click="logoutAndClose"
            class="bg-[#BF3131] text-white px-4 py-2 rounded-md font-semibold hover:bg-red-700 transition"
          >
            Logout
          </button>
        </template>
      </div>
    </div>
  </div>
</template>


<script setup>
import { ref, onMounted, watch, computed } from "vue";
import gsap from "gsap";
import { useRoute } from "vue-router";

const isMenuOpen = ref(false);
const loggedIn = ref(false);
const userName = ref(""); // New reactive state for the user's name/email
const userRole = ref("");
const route = useRoute();

function toggleMenu() {
  isMenuOpen.value = !isMenuOpen.value;
}



function logout() {
  localStorage.removeItem("token");
  localStorage.removeItem("user"); // IMPORTANT: Also remove the user object
  loggedIn.value = false;
  userName.value = ""; // Clear the user name
  window.location.href = "/login";
}

function closeMenu() {
  isMenuOpen.value = false;
}

function logoutAndClose() {
  logout();
  closeMenu();
}

function checkLogin() {
  const token = localStorage.getItem("token");
  const userString = localStorage.getItem("user");

  if (token && userString) {
    try {
      const user = JSON.parse(userString);
      loggedIn.value = true;
      // Display the user's name, fallback to email or "User"
      userName.value = user.name || user.email || "User";
      userRole.value = user.role || "user";
    } catch (e) {
      console.error("Error parsing user data:", e);
      loggedIn.value = false;
      userName.value = "";
      userRole.value = "";
    }
  } else {
    loggedIn.value = false;
    userName.value = "";
    userRole.value = "";
  }
}

onMounted(() => {
  gsap.from("#navbar", {
    y: -100,
    opacity: 0,
    duration: 1,
    ease: "power3.out",
  });
  let lastScroll = window.scrollY;
  window.addEventListener("scroll", () => {
    const currentScroll = window.scrollY;
    if (currentScroll > lastScroll && currentScroll > 50) {
      gsap.to("#navbar", {
        y: -100,
        duration: 0.5,
        ease: "power2.out",
      });
    } else {
      gsap.to("#navbar", {
        y: 0,
        duration: 0.5,
        ease: "power2.out",
      });
    }
    lastScroll = currentScroll;
  });
  checkLogin();
});
// Re-check login status when the route changes
watch(
  () => route.fullPath,
  () => {
    checkLogin();
  }
);

const userInitial = computed(() => {
  return userName.value ? userName.value.charAt(0).toUpperCase() : "?";
});
</script>

<style scoped>
.nav-link {
  position: relative;
  display: inline-block;
  transition: transform 0.3s ease;
}
.nav-link:hover {
  transform: translateY(-4px);
}
.nav-link::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 0;
  background-color: #ffe9a0;
  transition: width 0.3s ease;
}
.nav-link:hover::after {
  width: 100%;
}
</style>